export function defaultIfNil<T>(value: T | null, defaultValue: T): T {
  return value != null ? value : defaultValue;
}
